import { CUSTOMER_NEEDS } from '@ahmdigital/constants';

const headerData: { [key: string]: { subtitle: string; title: string } } = {
  [CUSTOMER_NEEDS.EXTRAS_COVER]: {
    subtitle: 'Browse insurance for services like dental, ambulance, optical, and physio.',
    title: 'Compare Extras Cover',
  },
  [CUSTOMER_NEEDS.HOSPITAL_COVER]: {
    subtitle: 'Browse insurance for in-hospital treatments and find cover to suit your needs.',
    title: 'Compare Hospital Cover',
  },
  [CUSTOMER_NEEDS.PACKAGE_COVER]: {
    subtitle: 'Explore packages for treatments and services that suit your needs.',
    title: 'Hospital and Extras Cover Comparison',
  },
};

export default headerData;
